module.exports = __webpack_public_path__ + "img/icone-anotacao.fe74f981.svg";